import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";
import frequencyOptions from "models/frequencyOptions.json";

export default forwardRef(function BoxEditForm(
  {
    data = {},
    onChange = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
    weeks = [],
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        type={type}
        layout={[
          {
            name: "address",
            label: "Delivery Address",
            placeholder: "Your delivery address here",
            type: "address",
            required: true,
            startIcon: "LocationOnOutlined",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
          },
          {
            name: "frequency",
            label: "Delivery Frequency",
            placeholder: "Delivery Frequency",
            type: "select",
            options: frequencyOptions,
            optionLabel: (option) => option?.name ?? "",
            required: true,
            itemSize: { lg: 2, md: 2, sm: 12, xs: 12 },
          },
          {
            name: "week_next_num",
            label: "Next Week Slot",
            type: "select",
            options: weeks,
            optionLabel: (option) => option?.label ?? "",
            itemSize: { lg: 2, md: 2, sm: 12, xs: 12 },
          },
          {
            name: "status",
            label: "Status",
            type: "select",
            optionLabel: (option) => option?.label ?? "",
            options: [
              { value: "1", label: "Active" },
              { value: "0", label: "Cancel" },
            ],
            itemSize: { lg: 2, md: 2, sm: 12, xs: 12 },
            fullWidth: true,
          },
        ]}
        isLabel
        alignItems="flex-start"
        fullWidth={true}
        direction="row"
        spacing={2}
      />
    </div>
  );
});
